import React, { useEffect, useState } from "react";
import { Header } from "../../components";
import { useEsportsAPI, HookResponse } from "../../hooks";
import "./SchedulePage.css";


export function SchedulePage() {
  const {getSchedule} = useEsportsAPI()

  const [schedule, setSchedule] = useState<HookResponse>({})

  useEffect(() => {
    getSchedule().then((res) =>  (res?.data)).then((data) => 
    {
      setSchedule(data)
    }
    );
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])


  console.log(schedule);
  console.log(schedule.data && Object.keys(schedule.data))


  const selectedDayEvents = schedule.data && schedule.data["friday"]

  const timings = selectedDayEvents && Object.keys(selectedDayEvents)
  const selectedDayEventSlots = selectedDayEvents && Object.values(selectedDayEvents)
  console.log(selectedDayEventSlots)
  console.log(selectedDayEventSlots)
  const stream1Events = selectedDayEventSlots && selectedDayEventSlots.map((item) => item[0])
  const stream2Events = selectedDayEventSlots && selectedDayEventSlots.map((item) => item[1])
  const stream3Events = selectedDayEventSlots && selectedDayEventSlots.map((item) => item[2])
  const stream4Events = selectedDayEventSlots && selectedDayEventSlots.map((item) => item[3])
  const stream5Events = selectedDayEventSlots && selectedDayEventSlots.map((item) => item[4])
  const stream6Events = selectedDayEventSlots && selectedDayEventSlots.map((item) => item[5])
  const formattedStreamEvents = [stream1Events || [""], stream2Events || [""], stream3Events || [""], stream4Events || [""], stream5Events || [""], stream6Events || [""]]
  console.log(stream1Events)

  return (
    <div className="container scheduleContainer">
      <Header title="Schedule" />
      <div className="tableContainer">
        <table>
          <thead>
            <tr>
              <th>Channel</th>
              {timings && timings.map((time, index) => (
                <th key={index}>{time}</th>
              ))}
            </tr>
          </thead>
          <tbody>
          {formattedStreamEvents.map((_, index) => (
              <tr>
              <td style={{ position: "static", textAlign: "center"}}>
                Game {index + 1}
              </td>
              {formattedStreamEvents && formattedStreamEvents[index].map((item) => (
                <td style={{ textAlign: "center" }}>
                {item}
              </td>
              ))}
            </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
